import React, { useState } from "react";
import ModalVideo from "react-modal-video";
import serviceData from "../../../data/services/serv2.json";
import { MdPlayArrow } from "react-icons/md";
import bgImg from "../../../assets/images/bg/7.jpg";
import styles from "./ServiceFour.module.scss";

const Serv2 = () => {
  const [modalStatus, isOpen] = useState(false);
  return (
    <div className={`vp__service ${styles.service3} position-relative`}>
      <div className="container-fluid">
        <div className="row no-gutters">
          <div
            className="col-12 col-lg-6"
            style={{
              backgroundImage: `url(${bgImg})`,
              backgroundRepeat: `no-repeat`,
              backgroundSize: `cover`
            }}
          >
            <div className={styles.serviceInner}>
              <h2>{serviceData.title}</h2>
              <p>{serviceData.content}</p>
                <p>{serviceData.content1}</p>
                <p>{serviceData.content2}</p>
            </div>
          </div>
          <div className="col-12 col-lg-6">
            <div className={styles.thumb}>
              <img
                src={require("./../../../assets/images/about/" +
                  serviceData.image)}
                alt="Ht-Call voip"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Serv2;
